import { render, staticRenderFns } from "./data24.vue?vue&type=template&id=d912420c&scoped=true"
import script from "./data24.vue?vue&type=script&lang=js"
export * from "./data24.vue?vue&type=script&lang=js"
import style1 from "./data24.vue?vue&type=style&index=1&id=d912420c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d912420c",
  null
  
)

export default component.exports